import { render, staticRenderFns } from "./NumberplateForm.vue?vue&type=template&id=77b4c930&scoped=true"
import script from "./NumberplateForm.vue?vue&type=script&lang=ts"
export * from "./NumberplateForm.vue?vue&type=script&lang=ts"
import style0 from "./NumberplateForm.vue?vue&type=style&index=0&id=77b4c930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4c930",
  null
  
)

export default component.exports